import { React, Component } from '@digsup/core-ui';
import PropTypes from 'prop-types';

export class Wrapper extends Component {
  render() {
    const { backgroundHorizontalAlign, backgroundVerticalAlign, children } =
      this.props;
    return (
      <div
        className={`c-avatar__wrapper c-avatar__wrapper--bg-h-align-${backgroundHorizontalAlign} c-avatar__wrapper--bg-v-align-${backgroundVerticalAlign}`}>
        {children}
      </div>
    );
  }
}

Wrapper.propTypes = {
  backgroundHorizontalAlign: PropTypes.string,
  backgroundVerticalAlign: PropTypes.string,
  children: PropTypes.any,
};

Wrapper.defaultProps = {
  backgroundHorizontalAlign: 'center',
  backgroundVerticalAlign: 'center',
};
